<template>
  <section class="population-card">
    <p class="population-card_header">{{ title }}</p>
    <div class="population-card_data">
      <div class="item" v-for="(item, index) in infoData" :key="index">
        <p class="name">{{ item.showTitle || item.key }}</p>
        <div v-if="item.type == 'table'" class="table-value">
          <template v-if="Array.isArray(item.value)">
            <el-table
              :data="item.value"
              :show-header="false"
              border
              :cell-style="columnStyle"
              :style="{ width: item.width }"
            >
              <el-table-column
                prop="dataItem"
                label="dataItem"
                align="left"
                min-width="33%"
              ></el-table-column>
              <el-table-column
                label="baseDataValue"
                align="left"
                min-width="67%"
              >
                <template slot-scope="props">
                  <el-my-popover
                    :item="props.row"
                    :value="props.row.baseDataValue"
                  ></el-my-popover>
                </template>
                <!-- <template slot-scope="props">
                  {{ props.row.baseDataValue }}
                </template> -->
              </el-table-column>
            </el-table>
          </template>
          <span v-else>
            {{ item.value }}
          </span>
        </div>
        <div v-else-if="item.type == 'list3'" class="table-value">
          <el-table
            v-if="Array.isArray(item.value)"
            :data="item.value"
            :show-header="false"
            border
            :cell-style="columnStyle2"
            :style="{ width: item.width }"
          >
            <el-table-column align="left">
              <template slot-scope="props">
                <el-my-popover
                  :item="props.row.name"
                  :value="props.row.name.value"
                ></el-my-popover>
              </template>
            </el-table-column>
            <el-table-column align="left">
              <template slot-scope="props">
                <el-my-popover
                  :item="props.row.value1"
                  :value="props.row.value1.value"
                ></el-my-popover>
              </template>
            </el-table-column>
            <el-table-column align="left">
              <template slot-scope="props">
                <el-my-popover
                  :item="props.row.value2"
                  :value="props.row.value2.value"
                ></el-my-popover>
              </template>
            </el-table-column>
          </el-table>
          <span v-else>
            {{ item.value }}
          </span>
        </div>
        <div v-else-if="item.type == 'list2'" class="table-value">
          <el-table
            v-if="Array.isArray(item.value)"
            :data="item.value"
            :show-header="false"
            border
            :cell-style="item.isNotHigh ? {} : columnStyle"
            :style="{ width: item.width }"
          >
            <el-table-column align="left" min-width="33%">
              <template slot-scope="props">
                <el-my-popover
                  :item="props.row.name"
                  :value="props.row.name.value"
                ></el-my-popover>
              </template>
            </el-table-column>
            <el-table-column align="left" min-width="67%">
              <template slot-scope="props">
                <el-my-popover
                  :item="props.row.value1"
                  :value="props.row.value1.value"
                ></el-my-popover>
              </template>
            </el-table-column>
          </el-table>
          <span v-else>
            {{ item.value }}
          </span>
        </div>
        <el-my-popover
          v-else
          :class="{ value: true, 'no-value': !item.value.baseDataValue }"
          :item="item.value"
          :value="
            item.value.baseDataValue
              ? item.value.baseDataValue + (item.value.dataItemUnit || '')
              : '--'
          "
        ></el-my-popover>
      </div>
    </div>
  </section>
</template>

<script>
import elMyPopover from "./elMyPopover.vue";
// import elMyPopover from "@/components/elMyPopover.vue";

export default {
  props: {
    title: {
      type: String,
    },
    infoData: {
      type: Array,
    },
  },
  components: {
    elMyPopover,
  },
  mounted() {
    console.log(11, this.infoData);
  },
  methods: {
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return "width: 33%";
      }
      if (columnIndex == 1) {
        return "width: 67%";
      }
    },
    columnStyle2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return "width: 30%";
      }
      if (columnIndex == 1) {
        return "width: 35%";
      }
      if (columnIndex == 2) {
        return "width: 35%";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.population-card {
  // margin: 0px 24px 32px 0;
  &_header {
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    padding-left: 20px;
    position: relative;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 8px;
      background-color: $theme;
    }
  }
  &_data {
    position: relative;
    padding: 28px 0 12px;
    display: flex;
    flex-wrap: wrap;
    .item {
      z-index: 2;
      display: flex;
      box-sizing: border-box;
      width: 50%;
      margin-bottom: 16px;
      &:nth-child(2n-1) {
        padding-left: 20px;
      }
      &:nth-child(2n) {
        padding-left: 8px;
      }
      padding-right: 98px;
      .name {
        width: 56px;
        font-size: 14px;
        /* font-family: PingFangSC-Medium, PingFang SC; */
        /* font-weight: 500; */
        // color: #ffffff;
        line-height: 20px;
        text-align: justify;
        text-justify: distribute-all-lines; /*ie6-8*/
        text-align-last: justify; /* ie9*/
        -moz-text-align-last: justify; /*ff*/
        -webkit-text-align-last: justify; /*chrome 20+*/
      }
      .table-value {
        text-align: left;
        margin-left: 14px;
        flex: 1;
        overflow: hidden;
      }
      .value {
        margin-left: 14px;
        flex: 1;
        text-align: left;
      }
    }
  }
}
</style>
